import { Container, Typography, Box, Divider } from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Container
      maxWidth='md'
      sx={{
        lineHeight: 1.3,
      }}
    >
      {/* Header */}

      <Typography
        variant='h4'
        gutterBottom
        sx={{ fontWeight: 'bold', color: '#181436', fontSize: { xs: '1.8rem', md: '2.5rem' } }}
      >
        Privacy Policy
      </Typography>
      <Typography variant='body2' color='text.secondary' gutterBottom>
        Effective Date: June 2, 2026
      </Typography>

      <Divider sx={{ my: { xs: 2, md: 3 } }} />

      {/* Sections */}
      <Box sx={{ mt: 2 }}>
        <Typography paragraph sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}>
          SingleCombo LLC (“SingleCombo,” “Company,” “we,” “us,” or “our”) respects your privacy.
          This Privacy Policy explains how we collect, use, disclose, and protect personal
          information when you use our website, mobile applications, merchant tools, or related
          services (collectively, the “Services”). This Policy applies to: Customers placing orders,
          Merchants using our platform, Delivery partners (where applicable) Website visitors
        </Typography>
      </Box>
      <Box sx={{ mt: 2 }}>
        {[
          {
            title: '1. Information We Collect',
            content:
              'We collect personal information that you provide directly to us, including your name, email address, phone number, delivery address, billing details, and account credentials. We also collect transaction information such as order history and payment details (processed through a third-party payment provider). Additionally, we automatically collect device and usage information including IP address, browser type, device type, operating system, and app activity. We may also receive information from payment processors, delivery partners, fraud prevention services, and marketing providers where applicable.',
          },
          {
            title: '2. How We Use Your Information',
            content:
              'We use your information to process and fulfill orders, coordinate deliveries, process payments, provide customer support, improve our Services, detect fraud, comply with legal obligations, and communicate with you about your account. With your consent, we may send promotional communications about offers and updates.',
          },
          {
            title: '3. Marketing Communications & No Sale of Personal Information',
            content:
              'SingleCombo LLC does not sell, rent, trade, or share personal information with third parties for their own marketing or advertising purposes. We do not disclose personal information for cross-context behavioral advertising. If you provide your phone number, you may receive transactional SMS messages related to orders or account activity. With your consent, you may also receive promotional SMS messages. SMS consent is not shared with third parties for marketing purposes. You may opt out of promotional SMS at any time by replying STOP. Message and data rates may apply. Consent to receive SMS is not a condition of purchase.',
          },
          {
            title: '4. Sharing of Information for Business Purposes',
            content:
              'We may share personal information only with trusted service providers that help operate our platform, including payment processors, cloud hosting providers, SMS delivery providers, delivery partners, and fraud prevention services. These providers are contractually required to use information solely for providing services to SingleCombo and not for their own marketing purposes. We may also disclose information if required by law or to protect our legal rights.',
          },
          {
            title: '5. Cookies & Tracking Technologies',
            content:
              'We use cookies and similar tracking technologies to maintain login sessions, improve website performance, analyze usage patterns, and personalize user experience. You may disable cookies in your browser settings; however, certain features of the Services may not function properly.',
          },
          {
            title: '6. Your Privacy Rights & Choices',
            content:
              'You may opt out of marketing emails or SMS at any time. You may request access to, correction of, or deletion of your personal information by contacting us. You may also disable location services through your device settings. To submit privacy-related requests, email info@singlecombo.com. We will verify your identity before processing certain requests.',
          },
          {
            title: '7. Data Security',
            content:
              'We implement reasonable administrative, technical, and physical safeguards designed to protect personal information from unauthorized access, disclosure, alteration, or destruction. However, no system can guarantee absolute security.',
          },
          {
            title: '8. Data Retention',
            content:
              'We retain personal information only as long as necessary to provide the Services, comply with legal obligations, resolve disputes, and enforce agreements. When information is no longer required, it is securely deleted or anonymized.',
          },
          {
            title: '9. Children’s Privacy',
            content:
              'Our Services are not directed to children under the age of 13. We do not knowingly collect personal information from children. If we learn that a child has provided personal information, we will take steps to delete it.',
          },
          {
            title: '10. Changes to This Policy',
            content:
              'We may update this Privacy Policy from time to time. Any changes will be posted on our website or app with an updated Last Updated date. Continued use of the Services after changes become effective constitutes acceptance of the revised policy.',
          },
          {
            title: '11. Contact Us',
            content:
              'SingleCombo Privacy Team\nEmail: info@singlecombo.com\n\nAddress:4556 Oakton, Skokie, IL 60077',
          },
        ].map((section, index) => (
          <Box key={index} sx={{ mb: { xs: 3, md: 4 } }}>
            <Typography
              variant='h6'
              gutterBottom
              sx={{ fontWeight: 600, fontSize: { xs: '1rem', md: '1.2rem' } }}
            >
              {section.title}
            </Typography>
            <Typography paragraph sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}>
              {section.content}
            </Typography>
          </Box>
        ))}
      </Box>
      <div style={{ height: '100px', color: 'white' }}>Empty space for mobile</div>
    </Container>
  );
};

export default PrivacyPolicy;
